import { Page } from '@/core/architecture'

import { ItemOrdersTemplate } from './template'
import { useViewModel } from './viewModel'

export const ItemOrders: Page = () => {
  const { state, actions } = useViewModel()

  return <ItemOrdersTemplate state={state} onFetchMore={actions.onFetchMore} />
}
